import { styled } from "@mui/system";
import { Box } from "@mui/material";
import themeCreator from "@Themes/themeCreator";

const customTheme = themeCreator();

const ReactTableStyles = styled(Box)(({ theme, tableHeight, minTableHeight = "100px" }) => ({
  marginRight: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",

  "& .filtersWrapper": {
    display: "flex",
    width: "100%",
  },
  ".toolbarLeftObject": {
    padding: `${theme.spacing(0, 5, 0, 0)}`,
  },
  ".toolbarRightObject": {
    marginLeft: "auto",
  },
  ".searchButton": {
    transform: "translateX(calc(100% - 550px))",
    zIndex: "1401",
  },
  ".toolbarButton": {
    color: customTheme.palette.secondary.main,
  },
  "& .overrideRoot": {
    border: "none",
    maxHeight: "69vh",
    minHeight: minTableHeight,
  },
  "& .overrideRoot .overrideCell": {
    border: "none",
    color: customTheme.palette.primary.dark,
  },
  "& .overrideRoot .overrideCell:first-child": {
    paddingLeft: theme.spacing(2),
  },

  "& .overrideRoot .MuiDataGrid-main": {
    backgroundColor: customTheme.palette.datagrid.main,
    minHeight: minTableHeight,
  },
  "& .overrideRoot .columnHeaderOverride": {
    backgroundColor: customTheme.palette.datagrid.odd,
    fontWeight: "900",  // Bolder font
    fontSize: "18px",  // Larger font size
    color: customTheme.palette.primary.main,
  },
  "& .overrideRow.Mui-odd": {
    backgroundColor: customTheme.palette.datagrid.odd,
    fontSize: "16px",  // Larger font size
  },
  "& .overrideRow.Mui-even": {
    backgroundColor: customTheme.palette.datagrid.even,
    fontSize: "16px",  // Larger font size
  },
  '& .tableHeight': {
    maxHeight: tableHeight, // default Height = 69vh
    minHeight: minTableHeight,
    '&.md': {
      maxHeight: "60vh",
      minHeight: minTableHeight,
    }
  },
  '& .overrideVirtualScroller': {
    minHeight: minTableHeight,
  },
  // Styling for the no rows overlay
  "& .MuiDataGrid-overlay": {
    minHeight: minTableHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    fontSize: "16px",
    color: customTheme.palette.text.secondary,
  },
  "& .overrideRoot.logsGrid .MuiDataGrid-row": {
    maxHeight: "none !important",
    minHeight: "40px",
    height: "auto",
    alignItems: "stretch",
  },
  "& .overrideRoot.logsGrid .logsWrapCell": {
    alignItems: "flex-start",
    overflow: "visible",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  "& .overrideRoot.logsGrid .searchButton": {
    transform: "translateX(calc(100% - 520px))",
  },
  "& .overrideRoot.logsGrid.logsTab .searchButton": {
    transform: "translateX(calc(100% - 720px))",
  },
  "& .overrideRoot.logsGrid .logsWrapCell .MuiDataGrid-cellContent": {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflow: "visible",
    lineHeight: 1.4,
  },
  "& .overrideRoot.logsGrid .MuiDataGrid-panel": {
    marginTop: theme.spacing(1.5),
    transform: "translateY(12px)",
  },
  "& .overrideRoot.logsEnhanced .MuiDataGrid-columnHeaders": {
    backgroundColor: customTheme.palette.primary.light,
    color: customTheme.palette.primary.contrastText,
    borderBottom: `1px solid ${customTheme.palette.primary.main}`,
  },
  "& .overrideRoot.logsEnhanced .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
    fontSize: "0.85rem",
  },
  "& .overrideRoot.logsEnhanced .MuiDataGrid-cell": {
    borderBottom: `1px solid ${customTheme.palette.grey[200]}`,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  "& .overrideRoot.logsEnhanced .MuiDataGrid-row:hover": {
    backgroundColor: customTheme.palette.action.hover,
  },
}));

export default ReactTableStyles;
